import { IProjectInfo } from 'library/ts/IProjectInfo';
import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { ImportRole } from 'library/ts/model/enums/config/ImportRole';
import { ImportType } from 'library/ts/model/enums/config/ImportType';
import { Protocol } from 'library/ts/model/enums/net/Protocol';
import { Domain } from 'library/ts/model/enums/web/Domain';
import { SubDomain } from 'library/ts/model/enums/web/SubDomain';
import { Namespace } from 'library/ts/namespaces/Namespace';
import { ProjectInfo } from 'library/ts/ProjectInfo';
import { AdapterId } from 'plugins/tag/plugin_data_service/ts/Application/model/enums/AdapterId';

const projectInfo: IProjectInfo = ProjectInfo;
const urlPrefix = `${Protocol.HTTPS}://${SubDomain.PLAYER_SERVICES}.${Domain.CBSCOM}/`;

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Tag Data Service configuration
 */
export const TagConfigDataService = {
	category: ConfigModuleCategory.PLUGIN,
	enabled: false,
	params: {
		preload: true,
		owner: 'TagModel',
		import: {
			app: {
				enabled: true,
				type: ImportType.SCRIPT,
				role: ImportRole.EXECUTABLE,
				namespace: Namespace.TAG_DATA_SERVICE,
				url: {
					regular: `${urlPrefix}${projectInfo?.app_output_dir?.tag_plugin_data_service?.token}/${projectInfo?.app_output_file?.tag_plugin_data_service?.js?.min?.token}`
				},
				order: 1
			}
		},
		config: {
			api: {
				adapterId: AdapterId.PLUTO
			},
			features: {
				PlaybackParamsBuilder: {
					enabled: true
				},
				UEC: {
					enabled: true
				},
				nextItem: {
					enabled: true
				},
				UserLists: {
					enabled: true
				}
			}
		}
	}
};